import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import withRouter from 'src/routes/withRouter';
import SetPower from './UI.SetPower';
import { Form, Drawer, Input, Divider, Button } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    submitHandler = () => {

    }
    render() {
        return (
            <Drawer
                title={`权限设置 - ${this.modulesState.appInfo.appName }`}
                width={460}
                onClose={() => ModulesAction.openDrawerSetPower()}
                visible={this.modulesState.drawerSetPowerVisible}
                bodyStyle={{}}
            >
                <SetPower />
            </Drawer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.DrawerSetPower.tsx